import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tools/emi-calculator/loan-prepayment/page.tsx");
